import s from './ItemTypeIconModal.module.css';
import {Image} from 'react-bootstrap';

import book from'../../asset/book.png';
import writingPng from'../../asset/writing.png';
import readingPng from'../../asset/reading.png';
import bigBookPng from'../../asset/big-book.png';
import grammarPng from'../../asset/grammar.png';
import speakingPng from'../../asset/speaking.png';
import listeningPng from'../../asset/listening.png';
import podcastPng from'../../asset/podcast.png';
import babyGirlPng from'../../asset/baby-girl.png';
import vipPng from'../../asset/vip.png';
import teachingNotePng from'../../asset/notes.png';
import tipsPng from'../../asset/tips.png';
import jailPng from'../../asset/jail.png';
import starPng from'../../asset/star.png';
import starDarkPng from'../../asset/star-dark.png';
import ideaPng from'../../asset/idea.png';
import scrabblePng from'../../asset/scrabble.png';
import keyVocabListeningPng from'../../asset/key-vocab-listening.png';
import keyVocabWritingPng from'../../asset/key-vocab-writing.png';


export default function ItemTypeIconModal ({itemType}){		

	switch(itemType) {
		case 51:
			return (
			<Image className={s.iconSmall} fluid
				src={babyGirlPng} rounded />	);
				
		case 72: // speaking
			return (
			<Image className={s.iconSmall} fluid
				src={speakingPng} rounded />	);
		case 87: // long-reading
			return (
			<Image className={s.iconSmall} fluid
				src={bigBookPng} rounded />	);
		case 88: // grammar
			return (
			<Image className={s.iconSmall} fluid
				src={grammarPng} rounded />	);
		case 73: // reading
			return (
			<Image className={s.iconSmall} fluid
				src={readingPng} rounded />	);
		case 74: // listening
			return (
			<Image className={s.iconSmall} fluid
				src={listeningPng} rounded />	);
		case 75: // pod class
			return (
			<Image className={s.iconSmall} fluid
				src={podcastPng} rounded />	);
		case 76: // writing class
			return (
			<Image className={s.iconSmall} fluid
				src={writingPng} rounded />	);
		case 77:
			return (
			<Image className={s.iconSmall} fluid
				src={ideaPng} rounded />	);
		case 78:
			return (
			<Image className={s.iconSmall} fluid
				src={scrabblePng} rounded />	);
		case 79: // vocab class
			return (
			<Image className={s.iconSmall} fluid
				src={keyVocabListeningPng} rounded />	);
		case 80: // vocab class
			return (
			<Image className={s.iconSmall} fluid
				src={keyVocabWritingPng} rounded />	);
		case 81: // VIP writing
			return (
			<Image className={s.iconSmall} fluid
				src={vipPng} rounded />	);
		case 82: // Teaching Note
			return (
			<Image className={s.iconSmall} fluid
				src={teachingNotePng} rounded />	);
		case 83: // Tips bag
			return (
			<Image className={s.iconSmall} fluid
				src={tipsPng} rounded />	);
				
		default :
			return (
			<Image className={s.iconSmall} fluid
				src={book} rounded />	);
	}
}